<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/o4Qb5j/tc-custom/9781459206557.jpg?1720280500366" alt="This image is the cover for the book Baby At His Door"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Baby At His Door
      </h1>
      <p class="bookDescription body article font2">
        <p>First, stranded beauty Lydia Kerr came rapping on his ranch house door. An unbidden sensuality clung to the mysterious damsel, and lawman Evan Powell couldn’t resist getting closer…. Though he was rocked by the man-woman union he experienced with Lydia, he would never again fall for the false promise of love. Then, a <i>second</i> wonder appeared on his stoop—an angelic, abandoned baby! And the sight of Lydia cradling the child caused an entirely unfamiliar pounding in his chest…. Love was knocking on his heart’s door—and wasn’t going <i>anywhere</i> until Evan opened up!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katherine Garbera
      </h2>
      
      <p class="authorDescription body article">Katherine Garbera is a <I>USA TODAY</I> bestselling author of more than 100 novels, which have been translated into over two dozen languages and sold millions of copies worldwide. She is the mother of two incredibly creative and snarky grown children, Katherine enjoys champagne, reading, walking and traveling with her husband. Visit her on the web at <a href="http://www.katherinegarbera.com">www.katherinegarbera.com</a>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?822348d6